import "./App.css";
// import WetherApp from "./Weather_App/WetherApp";
import Weather from "./Shahzaib_Weather_App/Weather";

function App() {
  return (
    <div className="App">
      {/* <WetherApp /> */}
      <Weather />
    </div>
  );
}

export default App;
